export default [
  { value: "sv", text: "Swedish (svenska)" },
  { value: "en", text: "English (English)" },
  { value: "ab", text: "Abkhaz (аҧсуа)" },
  { value: "aa", text: "Afar (Afaraf)" },
  { value: "af", text: "Afrikaans (Afrikaans)" },
  { value: "ak", text: "Akan (Akan)" },
  { value: "sq", text: "Albanian (Shqip)" },
  { value: "am", text: "Amharic (አማርኛ)" },
  { value: "ar", text: "Arabic (العربية)" },
  { value: "an", text: "Aragonese (Aragonés)" },
  { value: "hy", text: "Armenian (Հայերեն)" },
  { value: "as", text: "Assamese (অসমীয়া)" },
  { value: "av", text: "Avaric (авар мацӀ, магӀарул мацӀ)" },
  { value: "ae", text: "Avestan (avesta)" },
  { value: "ay", text: "Aymara (aymar aru)" },
  { value: "az", text: "Azerbaijani (azərbaycan dili)" },
  { value: "bm", text: "Bambara (bamanankan)" },
  { value: "ba", text: "Bashkir (башҡорт теле)" },
  { value: "eu", text: "Basque (euskara, euskera)" },
  { value: "be", text: "Belarusian (Беларуская)" },
  { value: "bn", text: "Bengali (বাংলা)" },
  { value: "bh", text: "Bihari (भोजपुरी)" },
  { value: "bi", text: "Bislama (Bislama)" },
  { value: "bs", text: "Bosnian (bosanski jezik)" },
  { value: "br", text: "Breton (brezhoneg)" },
  { value: "bg", text: "Bulgarian (български език)" },
  { value: "my", text: "Burmese (ဗမာစာ)" },
  { value: "ca", text: "Catalan; Valencian (Català)" },
  { value: "ch", text: "Chamorro (Chamoru)" },
  { value: "ce", text: "Chechen (нохчийн мотт)" },
  { value: "ny", text: "Chichewa; Chewa; Nyanja (chiCheŵa, chinyanja)" },
  { value: "zh", text: "Chinese (中文  (Zhōngwén), 汉语, 漢語)" },
  { value: "cv", text: "Chuvash (чӑваш чӗлхи)" },
  { value: "kw", text: "Cornish (Kernewek)" },
  { value: "co", text: "Corsican (corsu, lingua corsa)" },
  { value: "cr", text: "Cree (ᓀᐦᐃᔭᐍᐏᐣ)" },
  { value: "hr", text: "Croatian (hrvatski)" },
  { value: "cs", text: "Czech (česky, čeština)" },
  { value: "da", text: "Danish (dansk)" },
  { value: "dv", text: "Divehi; Dhivehi; Maldivian; (ދިވެހި)" },
  { value: "nl", text: "Dutch (Nederlands, Vlaams)" },
  { value: "eo", text: "Esperanto (Esperanto)" },
  { value: "et", text: "Estonian (eesti, eesti keel)" },
  { value: "ee", text: "Ewe (Eʋegbe)" },
  { value: "fo", text: "Faroese (føroyskt)" },
  { value: "fj", text: "Fijian (vosa Vakaviti)" },
  { value: "fi", text: "Finnish (suomi, suomen kieli)" },
  { value: "fr", text: "French (français, langue française)" },
  { value: "ff", text: "Fula; Fulah; Pulaar; Pular (Fulfulde, Pulaar, Pular)" },
  { value: "gl", text: "Galician (Galego)" },
  { value: "ka", text: "Georgian (ქართული)" },
  { value: "de", text: "German (Deutsch)" },
  { value: "el", text: "Greek, Modern (Ελληνικά)" },
  { value: "gn", text: "Guaraní (Avañeẽ)" },
  { value: "gu", text: "Gujarati (ગુજરાતી)" },
  { value: "ht", text: "Haitian; Haitian Creole (Kreyòl ayisyen)" },
  { value: "ha", text: "Hausa (Hausa, هَوُسَ)" },
  { value: "he", text: "Hebrew  (modern) (עברית)" },
  { value: "hz", text: "Herero (Otjiherero)" },
  { value: "hi", text: "Hindi (हिन्दी, हिंदी)" },
  { value: "ho", text: "Hiri Motu (Hiri Motu)" },
  { value: "hu", text: "Hungarian (Magyar)" },
  { value: "ia", text: "Interlingua (Interlingua)" },
  { value: "id", text: "Indonesian (Bahasa Indonesia)" },
  { value: "ga", text: "Irish (Gaeilge)" },
  { value: "ig", text: "Igbo (Asụsụ Igbo)" },
  { value: "ik", text: "Inupiaq (Iñupiaq, Iñupiatun)" },
  { value: "io", text: "Ido (Ido)" },
  { value: "is", text: "Icelandic (Íslenska)" },
  { value: "it", text: "Italian (Italiano)" },
  { value: "iu", text: "Inuktitut (ᐃᓄᒃᑎᑐᑦ)" },
  { value: "ja", text: "Japanese (日本語  (にほんご／にっぽんご))" },
  { value: "jv", text: "Javanese (basa Jawa)" },
  { value: "kl", text: "Greenlandic (kalaallisut, kalaallit oqaasii)" },
  { value: "kn", text: "Kannada (ಕನ್ನಡ)" },
  { value: "kr", text: "Kanuri (Kanuri)" },
  { value: "ks", text: "Kashmiri (कश्मीरी, كشميري‎)" },
  { value: "kk", text: "Kazakh (Қазақ тілі)" },
  { value: "km", text: "Khmer (ភាសាខ្មែរ)" },
  { value: "ki", text: "Kikuyu, Gikuyu (Gĩkũyũ)" },
  { value: "rw", text: "Kinyarwanda (Ikinyarwanda)" },
  { value: "ky", text: "Kirghiz, Kyrgyz (кыргыз тили)" },
  { value: "kv", text: "Komi (коми кыв)" },
  { value: "kg", text: "Kongo (KiKongo)" },
  { value: "ko", text: "Korean (한국어  (韓國語), 조선말  (朝鮮語))" },
  { value: "ku", text: "Kurdish (Kurdî, كوردی‎)" },
  { value: "kj", text: "Kwanyama, Kuanyama (Kuanyama)" },
  { value: "la", text: "Latin (latine, lingua latina)" },
  { value: "lb", text: "Luxembourgish, (Lëtzebuergesch)" },
  { value: "lg", text: "Luganda (Luganda)" },
  { value: "li", text: "Limburgish, Limburgan, Limburger (Limburgs)" },
  { value: "ln", text: "Lingala (Lingála)" },
  { value: "lo", text: "Lao (ພາສາລາວ)" },
  { value: "lt", text: "Lithuanian (lietuvių kalba)" },
  { value: "lu", text: "Luba-Katanga ()" },
  { value: "lv", text: "Latvian (latviešu valoda)" },
  { value: "gv", text: "Manx (Gaelg, Gailck)" },
  { value: "mk", text: "Macedonian (македонски јазик)" },
  { value: "mg", text: "Malagasy (Malagasy fiteny)" },
  { value: "ms", text: "Malay (bahasa Melayu, بهاس ملايو‎)" },
  { value: "ml", text: "Malayalam (മലയാളം)" },
  { value: "mt", text: "Maltese (Malti)" },
  { value: "mi", text: "Māori (te reo Māori)" },
  { value: "mr", text: "Marathi  (Marāṭhī) (मराठी)" },
  { value: "mh", text: "Marshallese (Kajin M̧ajeļ)" },
  { value: "mn", text: "Mongolian (монгол)" },
  { value: "na", text: "Nauru (Ekakairũ Naoero)" },
  { value: "nv", text: "Navajo, Navaho (Diné bizaad, Dinékʼehǰí)" },
  { value: "nb", text: "Norwegian Bokmål (Norsk bokmål)" },
  { value: "nd", text: "North Ndebele (isiNdebele)" },
  { value: "ne", text: "Nepali (नेपाली)" },
  { value: "ng", text: "Ndonga (Owambo)" },
  { value: "nn", text: "Norwegian Nynorsk (Norsk nynorsk)" },
  { value: "no", text: "Norwegian (Norsk)" },
  { value: "ii", text: "Nuosu (ꆈꌠ꒿ Nuosuhxop)" },
  { value: "nr", text: "South Ndebele (isiNdebele)" },
  { value: "oc", text: "Occitan (Occitan)" },
  { value: "oj", text: "Ojibwe, Ojibwa (ᐊᓂᔑᓈᐯᒧᐎᓐ)" },
  { value: "cu", text: "Old Church Slavonic (ѩзыкъ словѣньскъ)" },
  { value: "om", text: "Oromo (Afaan Oromoo)" },
  { value: "or", text: "Oriya (ଓଡ଼ିଆ)" },
  { value: "os", text: "Ossetian, Ossetic (ирон æвзаг)" },
  { value: "pa", text: "Panjabi, Punjabi (ਪੰਜਾਬੀ, پنجابی‎)" },
  { value: "pi", text: "Pāli (पाऴि)" },
  { value: "fa", text: "Persian (فارسی)" },
  { value: "pl", text: "Polish (polski)" },
  { value: "ps", text: "Pashto, Pushto (پښتو)" },
  { value: "pt", text: "Portuguese (Português)" },
  { value: "qu", text: "Quechua (Runa Simi, Kichwa)" },
  { value: "rm", text: "Romansh (rumantsch grischun)" },
  { value: "rn", text: "Kirundi (kiRundi)" },
  { value: "ro", text: "Romanian, Moldavian, Moldovan (română)" },
  { value: "ru", text: "Russian (русский язык)" },
  { value: "sa", text: "Sanskrit  (Saṁskṛta) (संस्कृतम्)" },
  { value: "sc", text: "Sardinian (sardu)" },
  { value: "sd", text: "Sindhi (सिन्धी, سنڌي، سندھی‎)" },
  { value: "se", text: "Northern Sami (Davvisámegiella)" },
  { value: "sm", text: "Samoan (gagana faa Samoa)" },
  { value: "sg", text: "Sango (yângâ tî sängö)" },
  { value: "sr", text: "Serbian (српски језик)" },
  { value: "gd", text: "Scottish Gaelic; Gaelic (Gàidhlig)" },
  { value: "sn", text: "Shona (chiShona)" },
  { value: "si", text: "Sinhala, Sinhalese (සිංහල)" },
  { value: "sk", text: "Slovak (slovenčina)" },
  { value: "sl", text: "Slovene (slovenščina)" },
  { value: "so", text: "Somali (Soomaaliga, af Soomaali)" },
  { value: "st", text: "Southern Sotho (Sesotho)" },
  { value: "es", text: "Spanish; Castilian (español, castellano)" },
  { value: "su", text: "Sundanese (Basa Sunda)" },
  { value: "sw", text: "Swahili (Kiswahili)" },
  { value: "ss", text: "Swati (SiSwati)" },
  { value: "ta", text: "Tamil (தமிழ்)" },
  { value: "te", text: "Telugu (తెలుగు)" },
  { value: "tg", text: "Tajik (тоҷикӣ, toğikī, تاجیکی‎)" },
  { value: "th", text: "Thai (ไทย)" },
  { value: "ti", text: "Tigrinya (ትግርኛ)" },
  { value: "bo", text: "Tibetan Standard, Tibetan, Central (བོད་ཡིག)" },
  { value: "tk", text: "Turkmen (Türkmen, Түркмен)" },
  { value: "tn", text: "Tswana (Setswana)" },
  { value: "to", text: "Tonga  (Tonga Islands) (faka Tonga)" },
  { value: "tr", text: "Turkish (Türkçe)" },
  { value: "ts", text: "Tsonga (Xitsonga)" },
  { value: "tt", text: "Tatar (татарча, tatarça, تاتارچا‎)" },
  { value: "tw", text: "Twi (Twi)" },
  { value: "ty", text: "Tahitian (Reo Tahiti)" },
  { value: "ug", text: "Uighur, Uyghur (Uyƣurqə, ئۇيغۇرچە‎)" },
  { value: "uk", text: "Ukrainian (українська)" },
  { value: "ur", text: "Urdu (اردو)" },
  { value: "uz", text: "Uzbek (zbek, Ўзбек, أۇزبېك‎)" },
  { value: "ve", text: "Venda (Tshivenḓa)" },
  { value: "vi", text: "Vietnamese (Tiếng Việt)" },
  { value: "vo", text: "Volapük (Volapük)" },
  { value: "wa", text: "Walloon (Walon)" },
  { value: "cy", text: "Welsh (Cymraeg)" },
  { value: "wo", text: "Wolof (Wollof)" },
  { value: "fy", text: "Western Frisian (Frysk)" },
  { value: "xh", text: "Xhosa (isiXhosa)" },
  { value: "yi", text: "Yiddish (ייִדיש)" },
  { value: "yo", text: "Yoruba (Yorùbá)" },
  { value: "za", text: "Zhuang, Chuang (Saɯ cueŋƅ, Saw cuengh)" }
];
